// "@기관" 이 한 단어로 줄바꿈되게 @ 바로 뒤(공백이 아닌 글자 앞)에 단어 결합자 U+2060(보이지 않음)을 넣는다.
// word-break: keep-all(사이트의 break-keep)이어도 브라우저는 기호 @ 와 한글 사이를 줄바꿈 자리로 봐서 "커뮤니티 @ / 중소벤처기업부" 처럼 끊는다 (CLAUDE.md Phase 11)
// 사이트 카드(Resume.jsx)와 다운로드 PDF(ResumeDownloadModal.jsx)가 같이 쓴다 (CLAUDE.md Phase 27)
export const keepAtWord = (text) => (typeof text === 'string' ? text.replace(/@(?=\S)/g, '@⁠') : text);
